// extracted by mini-css-extract-plugin
module.exports = {"alGhadeerCommonWrapper":"style_alGhadeerCommonWrapper__H6orx"};